import React from 'react';
import PropTypes from 'prop-types';

const IconCheckedFilled = ({ width = '16', height = '16', viewBox = '0 0 16 16', color = 'none' }) => {
    return <svg width={width} height={height} viewBox={viewBox} fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M7 0C5.14348 0 3.36301 0.737498 2.05025 2.05025C0.737498 3.36301 0 5.14348 0 7C0 8.85652 0.737498 10.637 2.05025 11.9497C3.36301 13.2625 5.14348 14 7 14C8.85652 14 10.637 13.2625 11.9497 11.9497C13.2625 10.637 14 8.85652 14 7C14 5.14348 13.2625 3.36301 11.9497 2.05025C10.637 0.737498 8.85652 0 7 0ZM6 10L3 7L4 6L6 8L10 4L11 5L6 10Z' fill={color} />
    </svg>;
};

IconCheckedFilled.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    color: PropTypes.string,
    viewBox: PropTypes.string
};

export default React.memo(IconCheckedFilled);
